import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'canyon-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Canyon Family Health',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 5077673226,
  email: 'support@canyonfamilyhealth.com',
  poweredByLogo: false,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/canyon/index.js